import React, {ReactElement} from 'react';
import callIconSrc from '@assets/images/medops/call.svg';

const CallIcon = (props: any): ReactElement => {
  return <img src={callIconSrc} {...props} />;
};
export default CallIcon;
